export {
  closeOutline,
  createOutline,
  documentOutline,
  downloadOutline,
  mailOutline,
  peopleOutline,
  searchOutline,
  settingsOutline,
} from 'ionicons/icons';
